import {Flex, Typography, Button} from 'antd';
import styles from './FilterHeader.module.scss';
import {useNavigate} from 'react-router-dom';
import {MRAppRoutes} from '../../../router/routes';
import {isExternalUser} from '../../../../permissions/usePermissions';

const TOUR_START_EVENT = 'mr-guided-tour:start';

export const FilterHeader = () => {
  const navigate = useNavigate();
  const externalUser = isExternalUser();

  return (
    <Flex
      data-tour-id="filter-header"
      style={{width: '100%', minHeight: '397px', backgroundColor: '#102241', position: 'relative', overflow: 'hidden'}}
      justify="space-between"
      align="center"
    >
      <Flex style={{width: '100%', marginLeft: '120px'}} vertical>
        <div className={styles.header__plank} />
        <Flex style={{width: '100%', marginBottom: '8px'}} gap="8px">
          <Typography.Text
            style={{
              color: '#FFFFFF',
              fontSize: '38px',
              lineHeight: '38px',
            }}
          >
            Welcome to
          </Typography.Text>
          <Typography.Title
            style={{color: '#FFFFFF', fontSize: '38px', fontWeight: 700, margin: 0, lineHeight: '38px'}}
            level={1}
          >
            Model Repository
          </Typography.Title>
        </Flex>
        <Typography.Text
          style={{color: '#FFFFFF', fontSize: '14px', margin: 0, lineHeight: '14px', marginBottom: '36px'}}
        >
          Model Repository is a central place for Health Economic Models in the company
        </Typography.Text>
        <Flex gap="24px">
          <Button type="primary" style={{height: 'auto'}} onClick={() => navigate(MRAppRoutes.MODEL_LIST)}>
            Show All Models
          </Button>
          {!externalUser && (
            <Button
              variant="outlined"
              data-tour-id="guided-tour-start"
              style={{backgroundColor: 'transparent', color: '#00857C', borderColor: '#00857C'}}
              onClick={() => window.dispatchEvent(new Event(TOUR_START_EVENT))}
            >
              Guided Tour
            </Button>
          )}
          <Button
            variant="outlined"
            style={{backgroundColor: 'transparent', color: '#00857C', borderColor: '#00857C'}}
            onClick={() =>
              window.open(
                'https://collaboration.merck.com/:w:/r/sites/modelexchange/_layouts/15/Doc.aspx?sourcedoc=%7B88C9B08D-CA62-425B-A898-1BF45A7D189B%7D&file=WM2.0%20Handbook%20for%20Model%20Owners.docx&action=default&mobileredirect=true',
                '_blank',
              )
            }
          >
            WebModel User Guide
          </Button>
        </Flex>
      </Flex>
      <div className={styles.header__circle} />
      <div className={styles.header_background} />
      <div className={styles.header__square} />
    </Flex>
  );
};
